/**
 * Create date: 2024-06-20
 * Screen 2082.C
 */

import LoadPanel from 'app/components/LoadPanel';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import useDictionary from 'hooks/useDictionary';
import React, { useContext, createContext, useState } from 'react';
import FormSearch from './FormSearch';
import DetailTab from './DetailTab';
import SummaryTab from './SummaryTab';

// create context
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2082_CContext';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

function M2082_C() {
  const { t }: any = useDictionary({ programId: '2082.C' });
  const [detailData, setDetailData] = useState<any>([]);
  const [summaryData, setSummaryData] = useState<any>([]);
  const [tabIndex, setTabIndex] = useState<any>(0);

  const value: any = {};
  /**
   * render
   */
  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <div style={{ marginBottom: 15, backgroundColor: '#fff' }}>
          <FormSearch
            t={t}
            tabIndex={tabIndex}
            setDetailData={setDetailData}
            setSummaryData={setSummaryData}
          />
        </div>
        <TabPanel
          className="custom-tabpanel-border-none bg-white"
          deferRendering={false}
          defaultSelectedIndex={tabIndex}
          selectedIndex={tabIndex}
          onSelectedIndexChange={e => setTabIndex(e)}
        >
          <Item title={t('Report On Specific Purchase And Sales (Detail)')}>
            <DetailTab t={t} store={detailData} />
          </Item>
          <Item title={t('Report On Specific Purchase And Sales (Summary)')}>
            <SummaryTab t={t} store={summaryData} />
          </Item>
        </TabPanel>
      </React.Suspense>
    </ModuleContext.Provider>
  );
}

export default M2082_C;
